module.exports = __webpack_public_path__ + "static/img/18mashang.fb804c99.gif";